// schema
import * as ISchema from "@schema";

// libraries
import { Router, Match } from "found";
import { RelayRefetchProp } from "react-relay";
import { PaymentMethod } from "@stripe/stripe-js";
import { WithStyles } from "@material-ui/core/styles/withStyles";

// internal
import { styles } from "./MixedCheckoutForm.styles";

// other
import { PlanInfo } from "@components/plan-and-billing-settings/plans-settings/plans-settings.constant";
import { updatePaymentInfo, clearPaymentInfo } from "@actions/payments.actions";
import { ControlData } from "@clockwise/web-commons/src/components/large-control-group";

export enum CheckoutFormRoute {
  Main = "Main",
  ManagePayment = "ManagePayment",
  PaymentConfirmation = "PaymentConfirmation",
}

interface ISeatPlanData extends ControlData {
  seatType: "Org" | "Team";
}

export interface IContainer {
  viewer: ISchema.IViewer;
  org: ISchema.IOrg;
  team: ISchema.ITeam | null;
  onChangeTeam?: (teamId: string) => void;
  billingRecurrence?: ISchema.SubscriptionInterval;
  onChangeBillingRecurrence?: (billingRecurrence: ISchema.SubscriptionInterval) => void;
  refetch: () => void;
  isDialog: boolean;
  onRequestClose?: () => void;
}

export interface IProps extends IContainer, WithStyles<typeof styles> {
  relay: RelayRefetchProp;
  router: Router;
  match: Match;
}
